/* WagNudge privacy-safe attribution entry resolver V1.
 * This file reads only the opaque `entry` value or a referrer hostname,
 * maps it to the generated registry, and never exposes raw inputs.
 */
(function () {
  'use strict';

  if (window.__wagnudgeAttributionEntryV1Loaded) return;
  window.__wagnudgeAttributionEntryV1Loaded = true;

  var registry = window.WAGNUDGE_ATTRIBUTION_REGISTRY_V1;
  var fields = registry && Array.isArray(registry.allowed_fields)
    ? registry.allowed_fields.slice()
    : [];
  var context = null;
  var initializationSent = false;
  var pathKey = window.location.pathname || '/';
  var contextStorageKey = 'wagnudge.attribution.entry.v1:' + pathKey;
  var initializationStoragePrefix = 'wagnudge.attribution.source-init.v1:' + pathKey + ':';

  function analyticsAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function copyControlled(candidate) {
    if (!candidate || typeof candidate !== 'object' || fields.length !== 8) return null;
    var clean = {};
    for (var index = 0; index < fields.length; index += 1) {
      var field = fields[index];
      var value = candidate[field];
      if (typeof value !== 'string' || !/^[a-z][a-z0-9_]{1,63}$/.test(value)) return null;
      clean[field] = value;
    }
    if (!registry.entries || registry.entries[clean.entry_key] !== candidate) return null;
    return clean;
  }

  function registryEntry(entryKey, publicOnly) {
    if (!registry || !registry.entries || typeof entryKey !== 'string') return null;
    if (publicOnly && registry.public_entry_keys.indexOf(entryKey) === -1) return null;
    return copyControlled(registry.entries[entryKey]);
  }

  function readStoredContext() {
    try {
      var raw = window.sessionStorage.getItem(contextStorageKey);
      if (!raw) return null;
      var stored = JSON.parse(raw);
      var canonical = registryEntry(stored && stored.entry_key, false);
      if (!canonical || JSON.stringify(canonical) !== JSON.stringify(stored)) return null;
      return canonical;
    } catch (error) {
      return null;
    }
  }

  function writeStoredContext(value) {
    if (!analyticsAllowed() || !value) return false;
    try {
      window.sessionStorage.setItem(contextStorageKey, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  function clearStoredContext() {
    try {
      window.sessionStorage.removeItem(contextStorageKey);
    } catch (error) {
      /* Storage may be unavailable; invalid input still fails closed in memory. */
    }
  }

  function cleanLandingAddress() {
    try {
      window.history.replaceState(
        window.history.state || null,
        '',
        window.location.pathname
      );
    } catch (error) {
      /* Address cleanup failure must not make raw data eligible for analytics. */
      context = null;
      return false;
    }
    return true;
  }

  function classifyReferrerHostname() {
    var hostname = '';
    try {
      hostname = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : '';
    } catch (error) {
      hostname = '';
    }

    if (!hostname || hostname === String(window.location.hostname || '').toLowerCase()) {
      return registry.fallback_entry_keys.same_origin_or_none;
    }

    for (var index = 0; index < registry.referrer_rules.length; index += 1) {
      var rule = registry.referrer_rules[index];
      try {
        if (new RegExp(rule.hostname_pattern, 'i').test(hostname)) return rule.entry_key;
      } catch (error) {
        return '';
      }
    }
    return registry.fallback_entry_keys.external;
  }

  function resolveInitialContext() {
    if (!registry || fields.length !== 8) return null;

    var url;
    try {
      url = new URL(window.location.href);
    } catch (error) {
      return null;
    }

    var hasEntry = url.searchParams.has('entry');
    var entryKey = hasEntry ? (url.searchParams.get('entry') || '') : '';
    var allowedSelectorState = true;
    url.searchParams.forEach(function (_value, key) {
      if (key !== 'breed' && key !== 'breed_size') allowedSelectorState = false;
    });
    var internalFragment = !url.hash || url.hash === '#breed-selector-grid' || url.hash === '#breed-problems';
    var mustClean = hasEntry || !allowedSelectorState || !internalFragment;

    if (hasEntry) {
      var publicEntry = registryEntry(entryKey, true);
      if (!cleanLandingAddress()) return null;
      if (!publicEntry) {
        clearStoredContext();
        return null;
      }
      return publicEntry;
    }

    if (mustClean && !cleanLandingAddress()) return null;
    var stored = readStoredContext();
    if (stored) return stored;
    return registryEntry(classifyReferrerHostname(), false);
  }

  function sourceInitializationAlreadySent(entryKey) {
    try {
      return window.sessionStorage.getItem(initializationStoragePrefix + entryKey) === 'sent';
    } catch (error) {
      return true;
    }
  }

  function markSourceInitializationSent(entryKey) {
    try {
      window.sessionStorage.setItem(initializationStoragePrefix + entryKey, 'sent');
      return true;
    } catch (error) {
      return false;
    }
  }

  function publishIfAllowed() {
    if (initializationSent || !context || !analyticsAllowed()) return false;
    if (!writeStoredContext(context)) return false;
    if (sourceInitializationAlreadySent(context.entry_key)) {
      initializationSent = true;
      return false;
    }
    if (!markSourceInitializationSent(context.entry_key)) return false;
    initializationSent = true;
    try {
      window.dispatchEvent(new CustomEvent('wagn:source_initialized', {
        detail: copyControlled(registry.entries[context.entry_key])
      }));
      return true;
    } catch (error) {
      return false;
    }
  }

  context = resolveInitialContext();

  window.WAGNUDGE_ATTRIBUTION_ENTRY_V1 = Object.freeze({
    getContext: function () {
      return analyticsAllowed() && context ? copyControlled(registry.entries[context.entry_key]) : null;
    },
    publishIfAllowed: publishIfAllowed
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', publishIfAllowed, { once: true });
  } else {
    publishIfAllowed();
  }
  document.addEventListener('visitorConsentCollected', publishIfAllowed, false);
  document.addEventListener('kiki:privacy-api-ready', publishIfAllowed, false);
})();
